exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body.imgCropper-dragging---1kbD6,body.imgCropper-dragging---1kbD6 *{cursor:move!important;cursor:-webkit-grabbing!important;cursor:grabbing!important;cursor:-webkit-grabbing,move;cursor:grabbing,move}.imgCropper-wrapper---1a3pj{display:block;position:relative;overflow:hidden;cursor:move;cursor:-webkit-grab;cursor:grab;cursor:-webkit-grab,move;cursor:grab,move}.imgCropper-container---1Zm1E{text-align:center}.imgCropper-container---1Zm1E,.imgCropper-container---1Zm1E>*{position:absolute;top:0;left:0;margin:0!important;padding:0!important;border:none!important}.imgCropper-container---1Zm1E>*{max-width:none;max-height:none;width:100%;height:100%}.imgCropper-sample---1zOH1{position:absolute!important;top:-100000px!important;left:-100000px!important;width:auto!important;height:auto!important}", ""]);

// exports
exports.locals = {
	"imgCropper-dragging": "imgCropper-dragging---1kbD6",
	"imgCropper-wrapper": "imgCropper-wrapper---1a3pj",
	"imgCropper-container": "imgCropper-container---1Zm1E",
	"imgCropper-sample": "imgCropper-sample---1zOH1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/libs/imageCropper/angular-image-cropper.scss
// module id = 1017
// module chunks = 0